module.exports = __webpack_public_path__ + "1f4a9de5abc889c85d99e3519bf1d716.png";